import React, {
  ReactNode,
  createContext,
  useReducer,
  useContext,
  useState,
} from "react";

import {
  NotificationsContextData,
  NotificationsReducer,
  initialState,
} from "./reducer";
import { notificationsRequest } from "./actions";
import { useAuthState } from "../Auth/context";

interface NotificationsProviderProps {
  children: ReactNode;
}

const NotificationsStateContext = createContext(initialState);
const NotificationsDispatchContext = createContext({});

export function useNotificationsState(): NotificationsContextData {
  const context = useContext(NotificationsStateContext);
  if (context === undefined) {
    throw new Error(
      "useNotificationsState must be used within a NotificationsProvider"
    );
  }

  return context;
}

export function useNotificationsDispatch() {
  const context = useContext(NotificationsDispatchContext);
  if (context === undefined) {
    throw new Error(
      "useNotificationsDispatch must be used within a NotificationsProvider"
    );
  }

  return context;
}

export const NotificationsProvider = ({
  children,
}: NotificationsProviderProps) => {
  const { accountInfo } = useAuthState();
  const [notification, dispatch] = useReducer(
    NotificationsReducer,
    initialState
  );
  const [accountId, setAccountId] = useState(-1);

  if (accountId !== accountInfo.id) {
    setAccountId(accountInfo.id);

    if (accountInfo.id >= 0) {
      try {
        notificationsRequest(dispatch);
      } catch (error) {
        console.log(error);
      }
    }
  }

  return (
    <NotificationsStateContext.Provider value={notification}>
      <NotificationsDispatchContext.Provider value={dispatch}>
        {children}
      </NotificationsDispatchContext.Provider>
    </NotificationsStateContext.Provider>
  );
};
